function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 80,
  rx: 12,
  fill: "#FEF5E6"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_diiii)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M62.4415 22.0611C63.5315 20.2842 62.2529 18 60.1684 18H46.8035C45.8571 18 44.9816 18.5016 44.503 19.3181L33.8135 37.553C32.7714 39.3307 34.0534 41.5683 36.1141 41.5683H43.5083L35.2218 59.7254C34.2431 61.8701 36.9529 63.7836 38.6466 62.1437L60.2 41.2745C61.9218 39.6075 60.7416 36.6921 58.3451 36.6921H53.4661L62.4415 22.0611Z",
  fill: "#FF6100"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.4415 22.0611C63.5315 20.2842 62.2529 18 60.1684 18H46.8035C45.8571 18 44.9816 18.5016 44.503 19.3181L33.8135 37.553C32.7714 39.3307 34.0534 41.5683 36.1141 41.5683H43.5083L35.2218 59.7254C34.2431 61.8701 36.9529 63.7836 38.6466 62.1437L60.2 41.2745C61.9218 39.6075 60.7416 36.6921 58.3451 36.6921H53.4661L62.4415 22.0611Z",
  fill: "url(#paint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.4415 22.0611C63.5315 20.2842 62.2529 18 60.1684 18H46.8035C45.8571 18 44.9816 18.5016 44.503 19.3181L33.8135 37.553C32.7714 39.3307 34.0534 41.5683 36.1141 41.5683H43.5083L35.2218 59.7254C34.2431 61.8701 36.9529 63.7836 38.6466 62.1437L60.2 41.2745C61.9218 39.6075 60.7416 36.6921 58.3451 36.6921H53.4661L62.4415 22.0611Z",
  fill: "url(#paint1_linear)",
  fillOpacity: 0.7
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_di)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_i)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 29.2,
  width: 23.3825,
  height: 3.2,
  rx: 1.6,
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_i)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 25.6289,
  y: 36.6665,
  width: 11.6912,
  height: 3.2,
  rx: 1.6,
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter4_i)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 17.5996,
  y: 36.6665,
  width: 3.2,
  height: 3.2,
  rx: 1.6,
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter5_i)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 20.127,
  y: 43.5999,
  width: 22.007,
  height: 3.2,
  rx: 1.6,
  fill: "white"
})));

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_diiii",
  x: 16.4615,
  y: 5.16172,
  width: 54.8264,
  height: 78.873,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -4.26667,
  dy: 8.55885
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6.35762
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.970833 0 0 0 0 0.698838 0 0 0 0 0.639132 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -12.8383
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 28.6093
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 0.728 0 0 0 0 0.575 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect2_innerShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -9.53643
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.13245
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_innerShadow",
  result: "effect3_innerShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6.35762
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.45033
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect3_innerShadow",
  result: "effect4_innerShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1.06667
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 0.656157 0 0 0 0 0.462745 0 0 0 0.8 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect4_innerShadow",
  result: "effect5_innerShadow"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_di",
  x: 13.8667,
  y: 28.0263,
  width: 30.4006,
  height: 23.0402,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2.13333
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.06667
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 0.248 0 0 0 0 0.2 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -1.17367
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.782446
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 0.488 0 0 0 0 0.2 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect2_innerShadow"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_i",
  x: 16,
  y: 28.6666,
  width: 23.3825,
  height: 3.73333,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.533333
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.266667
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.2 0 0 0 0 0.439216 0 0 0 0 1 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_i",
  x: 25.6289,
  y: 36.1332,
  width: 11.6912,
  height: 3.73333,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.533333
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.266667
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.2 0 0 0 0 0.439216 0 0 0 0 1 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_i",
  x: 17.5996,
  y: 36.1332,
  width: 3.2,
  height: 3.73333,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.533333
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.266667
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.2 0 0 0 0 0.439216 0 0 0 0 1 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter5_i",
  x: 20.127,
  y: 43.0665,
  width: 22.007,
  height: 3.73333,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.533333
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.266667
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.2 0 0 0 0 0.439216 0 0 0 0 1 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 48.5538,
  y1: -0.387302,
  x2: 48.5538,
  y2: 57.8222,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00520833,
  stopColor: "white",
  stopOpacity: 0.08
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0851933,
  stopOpacity: 0.08
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.336988,
  stopColor: "white",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.660917,
  stopColor: "white",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 48.5264,
  y1: 18,
  x2: 48.5264,
  y2: 69.2,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF8B44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})));

function SvgIconMore1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 85,
    viewBox: "0 0 80 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMore1);
export default __webpack_public_path__ + "static/media/icon_more_1.aa9eae82.svg";
export { ForwardRef as ReactComponent };